<script lang="ts">
    
    // props
    export let recordHand: string;

    const padding = {t: 10, l: 10, b: 10, r: 10};

    let turntable = {
        size: {
            w: 350,
            h: 450,
        },
        position: {
            x: padding.l,
            y: padding.t
        }
    }

    let mixer = {
        size: {
            w: 250,
            h: 300,
        },
        position: {
            x: padding.l + 360,
            y: padding.t + 150
        }
    }

    const updatePositions = (recordHand: string) => {
        if (recordHand == 'right') {
            turntable.position.x = padding.l + mixer.size.w + 10;
            mixer.position.x = padding.l;
        } else {
            turntable.position.x = padding.l;
            mixer.position.x = padding.l + turntable.size.w + 10;
        }
    }

    $: updatePositions(recordHand);

</script>


<style>
.turntable-box {
    display: block;
    max-height: 30vh;
}
.faceplate {
    fill: rgb(66, 66, 66);
}
/* #platterOutter {
}
#platterInner {
    fill: rgb(90, 79, 79);
} */
#armStick {
    fill: #ccc;
}
#needle {
    fill: rgb(66, 66, 66);
}
#postionMarkerLine {
    fill: #fff;
}

#recordLabel {
    fill:#ccc;
}
#spindle { fill: black; }

:global(.sampleSegment) {
    opacity: 0.7;
}

#startstop {
    stroke:black;
    stroke-width: 2px;
}
.buttonLight {
    fill: #ccc;
}
</style>

<svg class="turntable-box" viewBox="0 0 630 470"  width="100%" height="100%"
    version="1.1" xmlns="http://www.w3.org/2000/svg">

    <defs>
        <!-- https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Gradients -->

        <linearGradient id="gradientRecord1" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stop-color="black"/>
          <stop offset="50%" stop-color="#ccc" />
          <stop offset="100%" stop-color="black"/>
        </linearGradient>

        <!-- https://stackoverflow.com/questions/31888039/svg-draw-circle-with-curved-text-inside -->
        <!-- https://yqnn.github.io/svg-path-editor/ -->
        <path id="pathRecordLabel" d="M -40 15 a 30 30 0 0 0 80 0" />

        <!-- <pattern id="platterOutterBg" patternUnits="userSpaceOnUse" x="165" y="165" width="330" height="330">
            <image xlink:href="/platter_border.jpg" width="330" height="330" />
        </pattern> -->
    </defs>

    <g id="mixer" transform="translate({mixer.position.x} {mixer.position.y})">
        <rect id="faceplateMixer" x=0 y=0 width={mixer.size.w} height={mixer.size.h} class="faceplate"/>

        <g id="crossfader" transform="translate(75 250)">
            <rect id="crossfaderSlider" x=0 y=0 width=100 height=5 />
            <rect id="crossfaderKnob" x=0 y="-15" width=10 height=30 class="buttonLight">
                <!-- <animateTransform id="crossfaderAnim"
                    attributeType="XML" attributeName="transform"
                    type="translate"
                    repeatCount="indefinite"
                    restart="always"
                    /> -->
            </rect>
        </g>
    </g>

    <g id="turntable" transform="translate({turntable.position.x} {turntable.position.y})">

        <rect id="faceplateTurntable" x=0 y=0 width={turntable.size.w} height={turntable.size.h} class="faceplate" />

        <g id="platter" transform="translate(175 275)">
            <circle id="platterOutter" cx="0" cy="0" r="165"/>
            <!-- <circle id="platterOutter" cx="0" cy="0" r="165" fill="url(#platterOutterBg)"/> -->
            <!-- <circle id="platterInner" cx="0" cy="0" r="150"/> -->
        </g>

        <g id="recordGroup" transform="translate(175 275)">
            <g id="recordGroupInner">
                <circle id="record" cx="0" cy="0" r="148" fill="url(#gradientRecord1)" transform="rotate(-45)"/>

                <g id="segments" transform="rotate(40)">
                    <!-- <path id="sampleSegment0" class="sampleSegment" stroke="#446688" stroke-width="20" /> -->
                </g>

                <circle id="recordLabel" cx="0" cy="0" r="60"/>
                <text id="recordLabeltext" x="0" y="0" text-anchor="middle" transform="rotate(170)">
                    <textPath xlink:href="#pathRecordLabel" startOffset="50%">Ahhh Fresh</textPath>
                </text>
                <circle id="spindle" cx="0" cy="0" r="5"/>

                <!-- 
                <animateTransform id="recordRotationAnim" 
                    attributeType="XML" 
                    attributeName="transform" 
                    type="rotate" 
                    repeatCount="indefinite" 
                    restart="always" 
                    keytimes="0;1" 
                    values="0;45" 
                    dur="3s" /> -->                
            </g>
        </g>

        <g id="arm" transform="translate(80 90)">
            <circle id="armBase" cx="0" cy="0" r="60"/>
            <g transform="rotate(30)">
                <rect id="armStick" x="0" y="0" width="160" height="10" />
                <rect id="postionMarkerLine" x="191" y="-69" width="2" height="90" transform="rotate(10)"></rect>
                <g id="needle">
                    <rect id="needleMain" x="155" y="-5" width="45" height="20" />
                    <rect id="needleHandle" x="160" y="-20" width="5" height="20" />
                </g>
            </g>
        </g>

        <g id="buttonsRight">
            <circle id="power" cx="0" cy="0" r="15" transform="translate(288 425)"/>
            <rect id="startstop" x="0" y="0" width="35" height="45" transform="translate(307 397)" class="buttonLight"/>
        </g>

        <g id="r45Adapter" transform="translate(30 420)" >
            <circle id="r45Adapter" cx="0" cy="0" r="20" class="buttonLight"/>
            <circle id="r45AdapterSpindle" cx="0" cy="0" r="5"/>
        </g>

        <g id="pitch" transform="translate(210 20)">
            <rect id="pitchSlider" x="0" y="0" width="120" height="30"/>
            <rect id="pitchKnob" x="20" y="0" width="20" height="30" class="buttonLight"/>
        </g>

    </g>

</svg>
